// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'babel-polyfill';
import App from './App';
import $Lang from './utils/language';
import './utils/cookies';
import router from './router';
import store from './store';
import './permission';
import VeeValidate, { Validator } from 'vee-validate';
import zh from 'vee-validate/dist/locale/zh_CN';
import components from './components'; // 加载公共组件
import './directives';
import commonMixin from './mixins/common';
import ErrorUploadMixin from '@/mixins/ErrorUpload';
import VCharts from 'v-charts';

Vue.config.productionTip = false;
Vue.prototype.$Lang = $Lang;

Validator.localize('zh_CN', zh);
Vue.use(VeeValidate, {locale: 'zh_CN'});
Vue.use(components);
Vue.use(VCharts);
Vue.mixin(commonMixin);

if (process.env.NODE_ENV === 'production') {
    Vue.mixin(ErrorUploadMixin);
    Vue.config.errorHandler = ErrorUploadMixin.methods.jsErrorHandler;
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js